// extracted by mini-css-extract-plugin
module.exports = {"paginationItems":"PaginationBar_paginationItems__nOAFw"};